// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__xD_sP","inputWrap":"CustomTip_inputWrap__1w6dd"};